import React, {FC, useEffect, useRef} from "react";
import {Tab, Tabs} from "@mui/material";
import {NoteSectionDto} from "../../domain/NoteSectionDto";
import {NotesLocation} from "../../locations/NotesLocation";
import {NoteSectionContextMenu} from "./NoteSectionContextMenu";
import AddBoxIcon from '@mui/icons-material/AddBox';
import {NotesActions} from "../../redux/NotesSlice";
import {useAppDispatch, useAppSelector} from "../../hooks/ReduxHooks";

export const NoteSectionSidebar: FC = () => {
    const hasSearchResults = useAppSelector(s => !!s.notesState.searchResultPages);

    const noteSections = useAppSelector(s => s.notesState.searchResultSections ?? s.notesState.sections);
    const selectedSectionClientId = useAppSelector(s => s.notesState.selectedSectionClientId);

    const dispatch = useAppDispatch();

    const menuRef = useRef<HTMLDivElement>(null);

    function onAddNoteSection() {
        dispatch(NotesActions.addNoteSection());
    }

    function onNoteSectionChange(clientId: string) {
        NotesLocation.selectSectionByClientId(clientId);
    }

    function onSetContextSection(section: NoteSectionDto | undefined) {
        if (section) {
            dispatch(NotesActions.setNoteSectionContextMenu(section));
        }
    }

    function renderNoteSection(section: NoteSectionDto) {
        return (
            <Tab className="selectable"
                 key={section.Id}
                 color="secondary"
                 value={section.ClientId}
                 label={section.Name}
                 onContextMenu={() => onSetContextSection(section)}
            />
        );
    }

    const selectedSectionExists = !!noteSections.find(s => s.ClientId === selectedSectionClientId);

    useEffect(() => {
        if (noteSections.length && !selectedSectionExists) {
            NotesLocation.selectSectionByClientId(noteSections[0].ClientId!);
        }
    }, [noteSections, selectedSectionExists]);

    return (
        <>
            {!hasSearchResults && <Tab className="selectable add-item"
                                       value={-1}
                                       icon={<AddBoxIcon/>}
                                       onClick={onAddNoteSection}
                                       title="Add Section"
            />}
            <Tabs ref={menuRef}
                  orientation="vertical"
                  variant="scrollable"
                  indicatorColor="secondary"
                  textColor="inherit"
                  value={selectedSectionExists ? selectedSectionClientId : noteSections[0]?.ClientId ?? ""}
                  onChange={(e, newValue) => onNoteSectionChange(newValue)}
            >
                {hasSearchResults && !noteSections.length
                    ? <Tab label="No note sections found" disabled value=""/>
                    : noteSections.map(renderNoteSection)}
            </Tabs>
            <NoteSectionContextMenu elementRef={menuRef}/>
        </>
    );
};
